import axios from 'axios';
import { getToken, clearToken } from '../utils';

const token = getToken();
if (token) {
  axios.defaults.headers.token = token;
}

axios.interceptors.request.use(
  (config) => {
    if (getToken()) {
      return {
        ...config,
        params: {
          ...config.params,
          token: getToken(),
        },
      };
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);
axios.interceptors.response.use(
  (config) => {
    return config;
  },
  (err) => {
    if (err.response.data.status === 'need_login' || err.response.status === 401) {
      if (getToken()) {
        clearToken();
        window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
      }
    }
    return Promise.reject(err);
  },
);

export default axios;
